import DateType from "@trainline/dpi/lib/types/DateType";
import createPassengerFromType from "../../primitives/Passengers/helpers/createPassengerFromType";
import PassengerType from "../../primitives/Passengers/types/PassengerType";
import { SearchType } from "../types/searchType";
import { getRestrainedOutboundTime } from "./outboundAndInboundTimes";
const defaultFormValues = {
  origin: null,
  destination: null,
  via: null,
  passengers: [createPassengerFromType(PassengerType.Adult)],
  promo: null,
  outboundTime: getRestrainedOutboundTime(),
  inboundTime: "",
  outboundTimePreference: DateType.DepartAfter,
  inboundTimePreference: DateType.DepartAfter,
  searchType: SearchType.Single,
  railcardsATOC: [],
  bookingPromo: true
};
var defaultFormValues_default = defaultFormValues;
export {
  defaultFormValues_default as default
};
